import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectUserPermissions } from '../modules/auth.js';

const ACTION_ALIASES = {
  create: ['manage'],
  read: ['manage', 'show'],
  update: ['manage'],
  delete: ['manage', 'destroy'],
};

const mapStateToProps = (state) => ({
  permissions: selectUserPermissions(state),
});

AuthorizedAction.propTypes = {
  action: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  subject: PropTypes.string.isRequired,
};

function getActionAliases(action) {
  const aliases = ACTION_ALIASES[action] || [];
  return [action, ...aliases];
}

export function isAuthorized(action, subject, permissions) {
  if (permissions.manage?.includes('all')) {
    return true;
  }

  return getActionAliases(action).some((alias) => {
    return permissions[alias]?.includes(subject);
  });
}

export function isUnAuthorized(action, subject, permissions) {
  if (permissions.manage?.includes('all')) {
    return true;
  }

  return getActionAliases(action).some((alias) =>
    permissions[alias]?.includes(subject)
  );
}

function AuthorizedAction({ action, children, permissions, subject }) {
  return isAuthorized(action, subject, permissions) ? children : null;
}

export default connect(mapStateToProps)(AuthorizedAction);
